import { Col, Container, Row, Image } from "react-bootstrap";
import FooterLogo from '@gearghost/brand-assets/combination/toolbox-wordmark-horizontal-dark.svg';
import GoogleStore from '@/component/images/google.svg';
import { Link } from "react-router";
import { FaInstagram, FaReddit, FaYoutube } from "react-icons/fa6";
import { PATHS } from '@/navigation/paths';
import AppStoreBadge from '@/component/common/AppStoreBadge';

// The company's own profiles, in the order the footer shows them. The
// squares carry only an icon, so the name is each link's accessible name.
// index.html's structured data lists every one among the company's
// profiles; its test holds that copy to this one.
export const SOCIAL_PROFILES = [
  { id: "instagram", name: "Instagram", url: "https://www.instagram.com/gearghost.co", Icon: FaInstagram },
  { id: "youtube", name: "YouTube", url: "https://www.youtube.com/@gearghostco", Icon: FaYoutube },
  { id: "reddit", name: "Reddit", url: "https://www.reddit.com/r/gearghost/", Icon: FaReddit },
];

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row>
          <Col lg={12}>
            <div className="footer-info">
              <Link to={PATHS.home}>
                <Image
                  className="footer-logo"
                  src={FooterLogo}
                  alt="footer-logo"
                />
              </Link>
            </div>
            {/* Every link below points at a public info/legal route, so the
                list renders for logged-out visitors too; the /lastlooks QR
                landing page relies on guests exploring these. */}
            <ul className="footer-links">
              <li><Link to={PATHS.aboutUs}>About Us</Link></li>
              <li><Link to={PATHS.howItWorks}>How it works</Link></li>
              <li><Link to={PATHS.guides}>Guides</Link></li>
              <li><Link to={PATHS.blog} data-testid="footer-blog">Blog</Link></li>
              <li><Link to={PATHS.contactUs}>Contact Us</Link></li>
              <li><Link to={PATHS.damageAndTheft}>Damage & Theft</Link></li>
              <li><Link to={PATHS.savingsTiers}>Savings Tiers</Link></li>
              <li><Link to={PATHS.termsOfService}>Terms of Service</Link></li>
              <li><Link to={PATHS.privacyPolicy}>Privacy Policy</Link></li>
              <li><Link to={PATHS.rulesAndGuidelines}>Rules and Guidelines</Link></li>
              <li><Link to={PATHS.openSourceLicenses}>Open Source Licenses</Link></li>
            </ul>
            <div className="footer-google">
              {/* The live iOS listing, on the shared badge (bigger and bolder
                  than the artwork's native size). Android has no listing yet,
                  so its badge stays an unlinked "Coming Soon" until there is
                  a URL to point at. */}
              <AppStoreBadge size="md" />
              <div className="app-store-btn coming-soon">
                <Image src={GoogleStore} alt="Google Play" />
                <span className="coming-soon-badge">Coming Soon</span>
              </div>
            </div>
          </Col>
        </Row>

        <hr />

        <Row>
          <Col>
            <div className="bottom-footer">
              <div className="social_Links">
                {SOCIAL_PROFILES.map(({ id, name, url, Icon }) => (
                  <a
                    key={id}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={name}
                    data-testid={`footer-social-${id}`}
                  >
                    <Icon />
                  </a>
                ))}
              </div>
              <div className="made-in-la">
                <span>Made in L.A.</span>
                <span>Hecho en Los Angeles</span>
              </div>
              <div className="footer-copyright">
                <p className="mb-0">Copyright © 2026 GearGhost LLC</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
